import React, { Component } from 'react';

import EmisorSuggestions from '../../../emisores/suggestions/EmisorSuggestions';
import { Button } from 'react-bootstrap';

class EmisorSelection extends Component {
  handleOnSelect = (item) => {
    this.props.onChange({
      Emisor: {
        ...item,
      },
    });
  };

  handleOnEmisorReset = () => {
    this.props.onChange({
      Emisor: {},
    });
  };

  render() {
    const { data } = this.props;

    const isCompleted = !!data.Emisor && !!data.Emisor.id;

    return (
      <div>
        <EmisorSuggestions
          data={data.Emisor}
          onSelect={this.handleOnSelect}
        />

        {isCompleted && (
          <Button
            variant="secondary"
            className="mt-3"
            onClick={this.handleOnEmisorReset}
          >
            Cambiar
          </Button>
        )}
      </div>
    );
  }
}

export default EmisorSelection;
